import { render, staticRenderFns } from "./ManagementFeeAmount.vue?vue&type=template&id=371771d0&scoped=true&"
import script from "./ManagementFeeAmount.vue?vue&type=script&lang=js&"
export * from "./ManagementFeeAmount.vue?vue&type=script&lang=js&"
import style0 from "./ManagementFeeAmount.vue?vue&type=style&index=0&id=371771d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "371771d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('371771d0')) {
      api.createRecord('371771d0', component.options)
    } else {
      api.reload('371771d0', component.options)
    }
    module.hot.accept("./ManagementFeeAmount.vue?vue&type=template&id=371771d0&scoped=true&", function () {
      api.rerender('371771d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tenantProjects/projectControl/management/ManagementFeeAmount.vue"
export default component.exports